import React, { Component } from "react";
import "./Holdings.css";
import history from "./history";
import NavBarLogout from "./components/navbarLogout";
import Footer from "./components/footer";
import BestRates from "./components/bestRates";
import Current from "./components/current";

class Holdings extends Component {
  componentDidMount() {
    history.replace("/crypto/holdings");
  }
  render() {
    return (
      <React.Fragment>
        <div className="Holdings">
          <header className="Holdings-header">
            <NavBarLogout /> <Current />
          </header>
        </div>
        <BestRates />
        <Footer />
      </React.Fragment>
    );
  }
}

export default Holdings;
